'use client';

import {
  animate,
  motion,
  useInView,
  useMotionTemplate,
  useMotionValue,
  useTransform,
} from 'framer-motion';
import { useEffect, useRef } from 'react';

import Title from '@/components/common/Title';

interface CounterProps {
  percent: number;
  title: string;
}

const performanceData: CounterProps[] = [
  {
    percent: 80,
    title: 'Tiết kiệm thời gian',
  },
  {
    percent: 90,
    title: 'Tăng năng suất làm việc',
  },
  {
    percent: 90,
    title: 'Tự động hóa',
  },
  {
    percent: 100,
    title: 'Chính xác',
  },
];

const Counter = ({ percent, title }: CounterProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const count = useMotionValue(1);
  const value = useTransform(count, (end) => Math.round(end));
  useEffect(() => {
    if (isInView) {
      animate(count, percent, { duration: 2 });
    }
  }, [isInView]);
  return (
    <div ref={ref} className="items-center px-2 py-5 text-center lg:py-0">
      <motion.h2 className="text-center text-5xl text-white">
        {useMotionTemplate`${value}%`}
      </motion.h2>
      <span className="text-lg text-white">{title}</span>
    </div>
  );
};

export const PerformanceSection = () => {
  return (
    <section id="perfomance" className="section section-container">
      <Title
        title="Tinh giản quy trình, nhanh chóng tức thì"
        desc="Với Zump, việc quản lý bán hàng chưa bao giờ dễ dàng và hiệu quả đến thế!"
      />
      <motion.div
        className="flex size-full items-center justify-center"
        initial={{ opacity: 0, y: 20, scale: 0.9 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <div className="mt-16 grid w-full grid-cols-1 rounded-2xl bg-gradient-to-b from-primary-800 to-primary-600 px-6 py-16 sm:mx-24 sm:grid-cols-2 lg:mx-0 lg:grid-cols-4 lg:justify-between lg:px-12">
          {performanceData.map((data, key) => (
            <Counter {...data} key={key} />
          ))}
        </div>
      </motion.div>
    </section>
  );
};
